export default __webpack_public_path__ + "static/media/농어민후생연구회 흙.8bf3236b.svg";